/**
 * Route guard that redirects unauthenticated visitors to /login.
 *
 * The guard waits for the initial session load before deciding, to avoid
 * a flicker where a logged-in user briefly sees the login page on hard
 * refresh (supabase-js restores the session asynchronously from storage).
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useSession } from "@/hooks/auth/useSession";

export function RequireAuth() {
  const { data: session, isLoading } = useSession();
  const location = useLocation();

  if (isLoading) {
    return <FullScreenSpinner label="Loading session…" />;
  }

  if (!session) {
    // Preserve the attempted URL so /login can bounce back after sign-in.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

function FullScreenSpinner({ label }: { label: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-muted-foreground">
      <span className="text-sm">{label}</span>
    </div>
  );
}
